import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Button } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import axios from "axios";
import Swal from "sweetalert2";

import Titlebanner from "../../../globel_cmponents/title_banner";
import RenderField from "../../formcomponent/formfields/RenderField";
import requests from "../../../utils/Requests";
import TimeSlotPriceTable from "./Tables/TimeSlotPriceTable";

const API_OPTIONS = [
  { label: "Select API", value: "0" },
  { label: "Burj Khalifa", value: "1" },
  { label: "Museum Of The Future", value: "2" },
];

const validate = (values) => {
  const errors = {};

  if (!values.attractionGroupId || Number(values.attractionGroupId) === 0) {
    errors.attractionGroupId = "Required";
  }
  if (!values.attractionId || Number(values.attractionId) === 0) {
    errors.attractionId = "Required";
  }
  if (!values.ticketTypeId || Number(values.ticketTypeId) === 0) {
    errors.ticketTypeId = "Required";
  }
  if (!values.apiId || Number(values.apiId) === 0) {
    errors.apiId = "Required";
  }
  if (!values.timeSlot || values.timeSlot.trim() === "") {
    errors.timeSlot = "Required";
  }

  return errors;
};

const sampleTimeSlots = [
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

const normalizeTimeSlot = (value) => {
  if (!value) return "";
  const trimmed = value.trim();
  if (/^\d{2}:\d{2}$/.test(trimmed)) {
    return `${trimmed}:00`;
  }
  if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed)) {
    return trimmed;
  }
  return trimmed;
};

const TimeSlotPrice = (props) => {
  const { handleSubmit, reset, initialize, change } = props;
  const defaultGroupOption = { label: "Select Attraction Group", value: "0" };
  const defaultAttractionOption = { label: "Select Attraction", value: "0" };
  const defaultTicketOption = { label: "Select Ticket Type", value: "0" };
  const defaultApiOption = API_OPTIONS[0];

  const [groupOptions, setGroupOptions] = useState([defaultGroupOption]);
  const [attractionOptions, setAttractionOptions] = useState([
    defaultAttractionOption,
  ]);
  const [ticketTypeOptions, setTicketTypeOptions] = useState([
    defaultTicketOption,
  ]);
  const [tableData, setTableData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("0");
  const [selectedAttraction, setSelectedAttraction] = useState("0");
  const [selectedTicketType, setSelectedTicketType] = useState("0");
  const [selectedApi, setSelectedApi] = useState("0");
  const [isEditing, setIsEditing] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);
  const [editingId, setEditingId] = useState(0);

  useEffect(() => {
    initialize({
      attractionGroupId: "0",
      attractionId: "0",
      ticketTypeId: "0",
      timeSlot: "",
      primeTime: false,
      apiId: "0",
    });
    fetchGroups();
  }, [initialize]);

  const fetchGroups = () => {
    axios
      .post(requests.getallparkgroup, { attractionsId: 0 })
      .then((res) => {
        const values = [
          defaultGroupOption,
          ...res.data.map((item) => ({
            label: item.grpName,
            value: String(item.attractionGroupId),
          })),
        ];
        setGroupOptions(values);
      })
      .catch((err) => console.log(err));
  };

  const fetchAttractionsByGroup = (
    groupId,
    { resetSelection = true } = {}
  ) => {
    if (!groupId || groupId === "0") {
      setAttractionOptions([defaultAttractionOption]);
      if (resetSelection) {
        setSelectedAttraction("0");
        change("attractionId", "0");
      }
      setTicketTypeOptions([defaultTicketOption]);
      change("ticketTypeId", "0");
      setSelectedTicketType("0");
      return Promise.resolve([]);
    }

    return axios
      .post(requests.getattractionallbygroup, { attGroup: Number(groupId) })
      .then((res) => {
        const options = [
          defaultAttractionOption,
          ...res.data.map((item) => ({
            label: item.attName,
            value: String(item.attractionsId),
          })),
        ];
        setAttractionOptions(options);
        if (resetSelection) {
          setSelectedAttraction("0");
          change("attractionId", "0");
          setTicketTypeOptions([defaultTicketOption]);
          change("ticketTypeId", "0");
          setSelectedTicketType("0");
        }
        return options;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  };

  const fetchTicketTypesByAttraction = (
    attractionId,
    { resetSelection = true } = {}
  ) => {
    if (!attractionId || attractionId === "0") {
      setTicketTypeOptions([defaultTicketOption]);
      if (resetSelection) {
        change("ticketTypeId", "0");
        setSelectedTicketType("0");
      }
      return Promise.resolve([]);
    }

    return axios
      .post(requests.getTicketTypeListByAttraction, {
        ttAttractionId: Number(attractionId),
        platformId: 1,
      })
      .then((res) => {
        const options = [
          defaultTicketOption,
          ...res.data.map((item) => ({
            label: item.ttTicketType,
            value: String(item.ticketTypeId),
          })),
        ];
        setTicketTypeOptions(options);
        if (resetSelection) {
          change("ticketTypeId", "0");
          setSelectedTicketType("0");
        }
        return options;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  };

  const resetFormState = (preserveSelections = false) => {
    if (preserveSelections) {
      change("timeSlot", "");
      change("primeTime", false);
      change("apiId", selectedApi);
      setDisableSelect(false);
      setIsEditing(false);
      setEditingId(0);
      if (
        selectedTicketType &&
        selectedTicketType !== "0" &&
        selectedApi &&
        selectedApi !== "0"
      ) {
        axios
          .post(requests.getTimeSlotPriceList, {
            ticketTypeId: Number(selectedTicketType),
            apiId: Number(selectedApi || 0),
          })
          .then((response) => {
            setTableData(response.data || []);
          })
          .catch((error) => console.log(error));
      } else {
        setTableData([]);
      }
      return;
    }

    reset();
    initialize({
      attractionGroupId: "0",
      attractionId: "0",
      ticketTypeId: "0",
      timeSlot: "",
      primeTime: false,
      apiId: "0",
    });
    setSelectedGroup("0");
    setSelectedAttraction("0");
    setSelectedTicketType("0");
    setSelectedApi("0");
    setAttractionOptions([defaultAttractionOption]);
    setTicketTypeOptions([defaultTicketOption]);
    setDisableSelect(false);
    setIsEditing(false);
    setEditingId(0);
    setTableData([]);
  };

  const buildPayload = (values, includeId = false) => {
    const timeSlotValue = normalizeTimeSlot(values.timeSlot || "");
    const apiValue = Number(values.apiId || selectedApi || 0);
    const payload = {
      ticketTypeId: Number(values.ticketTypeId || 0),
      timeSlot: timeSlotValue,
      primeTime: values.primeTime ? true : false,
      apiId: apiValue,
    };

    if (includeId) {
      payload.timeSlotPriceId = editingId;
    }

    return payload;
  };


  const handleSave = (values) => {
    const payload = buildPayload(values);
    if (!payload.timeSlot) {
      Swal.fire({
        title: "Warning!",
        text: "Please enter a valid time slot.",
        icon: "warning",
      });
      return;
    }
    if (!payload.apiId || payload.apiId === 0) {
      Swal.fire({
        title: "Warning!",
        text: "Please select an API.",
        icon: "warning",
      });
      return;
    }

    axios
      .post(requests.setTimeSlotPrice, payload)
      .then((response) => {
        if (response.data.errCode === 0) {
          Swal.fire({
            title: "Success!",
            text: "Time slot added successfully",
            icon: "success",
          });
          resetFormState(true);
        } else {
          Swal.fire({
            title: "Warning!",
            text:
              response.data.errMessage ||
              "Something went wrong. Please try again.",
            icon: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Unable to save time slot.",
          icon: "error",
        });
      });
  };

  const handleUpdate = (values) => {
    if (!editingId) {
      Swal.fire({
        title: "Warning!",
        text: "Please select a record to update.",
        icon: "warning",
      });
      return;
    }

    const payload = buildPayload(values, true);
    if (!payload.timeSlot) {
      Swal.fire({
        title: "Warning!",
        text: "Please enter a valid time slot.",
        icon: "warning",
      });
      return;
    }
    if (!payload.apiId || payload.apiId === 0) {
      Swal.fire({
        title: "Warning!",
        text: "Please select an API.",
        icon: "warning",
      });
      return;
    }

    axios
      .post(requests.updateTimeSlotPrice, payload)
      .then((response) => {
        if (response.data.errCode === 0) {
          Swal.fire({
            title: "Success!",
            text: "Time slot updated successfully",
            icon: "success",
          });
          resetFormState(true);
        } else {
          Swal.fire({
            title: "Warning!",
            text:
              response.data.errMessage ||
              "Something went wrong. Please try again.",
            icon: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Unable to update time slot.",
          icon: "error",
        });
      });
  };

  const handleGroupChange = async (value) => {
    setSelectedGroup(value);
    change("attractionGroupId", value);
    await fetchAttractionsByGroup(value);
    setSelectedAttraction("0");
    setSelectedTicketType("0");
  };

  const handleAttractionChange = async (value) => {
    setSelectedAttraction(value);
    change("attractionId", value);
    await fetchTicketTypesByAttraction(value);
    setSelectedTicketType("0");
  };

  const handleTicketTypeChange = async (value) => {
    setSelectedTicketType(value);
    change("ticketTypeId", value);
    if (!value || value === "0" || !selectedApi || selectedApi === "0") {
      setTableData([]);
      return;
    }
    await axios
      .post(requests.getTimeSlotPriceList, {
        ticketTypeId: Number(value || 0),
        apiId: Number(selectedApi || 0),
      })
      .then((response) => {
        setTableData(response.data || []);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (
      selectedTicketType &&
      selectedTicketType !== "0" &&
      selectedApi &&
      selectedApi !== "0"
    ) {
      axios
        .post(requests.getTimeSlotPriceList, {
          ticketTypeId: Number(selectedTicketType),
          apiId: Number(selectedApi || 0),
        })
        .then((response) => {
          setTableData(response.data || []);
        })
        .catch((error) => console.log(error));
    } else {
      setTableData([]);
    }
  }, [selectedTicketType, selectedApi]);

  const handleEditRow = async (rowData) => {
    try {
      setDisableSelect(true);
      setIsEditing(true);
      setEditingId(rowData.timeSlotPriceId);

      const groupIdStr = String(rowData.attractionGroupId || 0);
      const attractionIdStr = String(rowData.attractionId || 0);
      const ticketTypeIdStr = String(rowData.ticketTypeId || 0);
      const apiIdStr = String(rowData.apiId || 0);

      setSelectedGroup(groupIdStr);
      change("attractionGroupId", groupIdStr);
      await fetchAttractionsByGroup(groupIdStr, { resetSelection: false });

      setSelectedAttraction(attractionIdStr);
      change("attractionId", attractionIdStr);
      await fetchTicketTypesByAttraction(attractionIdStr, {
        resetSelection: false,
      });

      setSelectedTicketType(ticketTypeIdStr);
      change("ticketTypeId", ticketTypeIdStr);
      setSelectedApi(apiIdStr);
      change("apiId", apiIdStr);

      change(
        "timeSlot",
        rowData.timeSlot ? rowData.timeSlot.substring(0, 5) : ""
      );
      change("primeTime", rowData.primeTime ? true : false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteRow = (rowData) => {
    axios
      .post(requests.removeTimeSlotPrice, {
        timeSlotPriceId: rowData.timeSlotPriceId,
      })
      .then((res) => {
        if (res.data.errCode === 0) {
          Swal.fire({
            title: "Deleted!",
            text: "Record removed successfully.",
            icon: "success",
          });
          resetFormState(true);
        } else {
          Swal.fire({
            title: "Warning!",
            text:
              res.data.errMessage ||
              "Unable to delete the selected record.",
            icon: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Unable to delete the selected record.",
          icon: "error",
        });
      });
  };

  const handleSampleTimeSelect = (value) => {
    change("timeSlot", value);
  };

  const handleApiChange = async (value) => {
    setSelectedApi(value);
    change("apiId", value);
    if (
      value &&
      value !== "0" &&
      selectedTicketType &&
      selectedTicketType !== "0"
    ) {
      await axios
        .post(requests.getTimeSlotPriceList, {
          ticketTypeId: Number(selectedTicketType || 0),
          apiId: Number(value || 0),
        })
        .then((response) => {
          setTableData(response.data || []);
        })
        .catch((error) => console.log(error));
    } else {
      setTableData([]);
    }
  };

  return (
    <>
      <Titlebanner title="Attraction API - Time Slots" />
      <Card>
        <CardBody>
          <Row>
            <Col md="6">
              <Field
                name="attractionGroupId"
                label="Attraction Group"
                component={RenderField.RenderSelectField}
                options={groupOptions}
                isDisabled={disableSelect}
                onChange={handleGroupChange}
              />
            </Col>
            <Col md="6">
              <Field
                name="attractionId"
                label="Attraction"
                component={RenderField.RenderSelectField}
                options={attractionOptions}
                isDisabled={disableSelect || selectedGroup === "0"}
                onChange={handleAttractionChange}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="ticketTypeId"
                label="Ticket Type"
                component={RenderField.RenderSelectField}
                options={ticketTypeOptions}
                isDisabled={disableSelect || selectedAttraction === "0"}
                onChange={handleTicketTypeChange}
              />
            </Col>
            <Col md="6">
              <Field
                name="apiId"
                label="API"
                component={RenderField.RenderSelectField}
                options={API_OPTIONS}
                isDisabled={disableSelect}
                onChange={handleApiChange}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="timeSlot"
                type="text"
                label="Time Slot Starting (HH:MM)"
                component={RenderField.RenderTextField}
              />
              <div className="mt-2">
                {sampleTimeSlots.map((slot) => (
                  <Button
                    key={slot}
                    color="secondary"
                    size="sm"
                    outline
                    className="mr-1 mb-1"
                    onClick={() => handleSampleTimeSelect(slot)}
                  >
                    {slot}
                  </Button>
                ))}
              </div>
            </Col>
      <Col md="3">
        <div
          style={{
            marginTop: "35px",
          }}
        >
          <Field
            name="primeTime"
            type="checkbox"
            component={RenderField.RendercheckboxField}
            label="Prime Time"
          />
        </div>
      </Col>
          </Row>
          <div className="float-right">
            <Button
              color="success"
              onClick={handleSubmit(handleSave)}
              className="mr-2"
              disabled={isEditing}
            >
              Save
            </Button>
            <Button
              color="primary"
              onClick={handleSubmit(handleUpdate)}
              className="mr-2"
            >
              Update
            </Button>
            <Button color="danger" onClick={() => resetFormState(false)}>
              Cancel
            </Button>
          </div>
        </CardBody>
      </Card>

      <TimeSlotPriceTable
        data={tableData}
        onEdit={handleEditRow}
        onDelete={handleDeleteRow}
      />
    </>
  );
};

export default reduxForm({
  form: "TimeSlotPriceForm",
  validate,
})(TimeSlotPrice);

